<template>
    <div class="table_container">
        <common-layout>
            <div slot="header">
                <h3>技术转移管理</h3>
            </div>
            <div slot="container">
                <!-- <div class="handle-box">
                    <el-input style="width:30%;margin:0 10px" placeholder="视频关键词" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-select>
                        <el-option value label="全部"></el-option>
                        <el-option value="1" label="学习课程"></el-option>
                        <el-option value="2" label="点播课程"></el-option>
                    </el-select>
                </div> -->
                <div id="table">
                    <el-table ref="multipleTable" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }" :data="tableData" style="width: 100%" type="index" >
                        <el-table-column type="index" width="100" label="序号" align="center"></el-table-column>
                        <el-table-column prop="title" label="标题" align="center"></el-table-column>
                        <el-table-column prop="typeData" label="分类" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="添加日期" align="center"></el-table-column>
                        <el-table-column prop="creatorName" label="操作员" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <div class="grid-content bg-purple-light">
                        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper"
                            :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
                    </div>
                </div>
            </div>
        </common-layout>
        <el-dialog
            title="修改技术转移管理"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            width="50%"
            >
            <el-form :model="form" ref="form">
                <el-form-item
                    label="标题"
                    label-position="top"
                >
                    <el-input
                        v-model="form.title"
                        autocomplete="off"
                        placeholder="请输入标题"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="分类数据 (数据顺序：节能环保|清洁生产|清洁能源|循环农业|中医中药|文化旅游|通道物流|军民融合|数据信息|先进制度)"
                    label-position="top"
                >
                    <el-input
                    type="textarea"
                    v-model="form.typeData"
                    :rows="2"
                    placeholder="请输入分类数据 (数据顺序：节能环保|清洁生产|清洁能源|循环农业|中医中药|文化旅游|通道物流|军民融合|数据信息|先进制度)"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="中国科技大学转移甘肃中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.kjUniversityTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入中国科技大学转移甘肃中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="中国科技大学转移甘肃中心名单"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="kjUniversityTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写中国科技大学转移甘肃中心名单'"
                        v-model="form.kjUniversityTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="国家技术转移东部中心甘肃分中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.countryTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入国家技术转移东部中心甘肃分中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="国家技术转移东部中心甘肃分中心名单"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="countryTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写国家技术转移东部中心甘肃分中心名单'"
                        v-model="form.countryTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="张江兰白科技创新改革试验区技术转移中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.zjTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入张江兰白科技创新改革试验区技术转移中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="张江兰白科技创新改革试验区技术转移中心名单"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="zjTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写张江兰白科技创新改革试验区技术转移中心名单'"
                        v-model="form.zjTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="新加坡南洋理工大学技术转移甘肃中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.singaporeTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入新加坡南洋理工大学技术转移甘肃中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="新加坡南洋理工大学技术转移甘肃中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="singaporeTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写新加坡南洋理工大学技术转移甘肃中心 (数据间用|（竖线）相隔)'"
                        v-model="form.singaporeTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="北京大学技术甘肃转移中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.bjTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入北京大学技术甘肃转移中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="北京大学技术甘肃转移中心明单"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="bjTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写北京大学技术甘肃转移中心明单'"
                        v-model="form.bjTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="瑞士洛桑大学技术转移甘肃中心 (数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.switzerlandTransferGansuCenter"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入瑞士洛桑大学技术转移甘肃中心 (数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="瑞士洛桑大学技术转移甘肃中心名单"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="switzerlandTransferGansuCenterList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写瑞士洛桑大学技术转移甘肃中心名单'"
                        v-model="form.switzerlandTransferGansuCenterList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="甘肃总成果（四个标题）(共四条数据，不能改顺序，数据间用|（竖线）相隔)"
                    label-position="top"
                >
                    <el-input
                        v-model="form.totalResults"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入甘肃总成果（四个标题）(共四条数据，不能改顺序，数据间用|（竖线）相隔)"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="甘肃成果标题1"
                    label-position="top"
                >
                    <el-input
                        v-model="form.totalRachievementTitleOneesults"
                        placeholder="请输入甘肃成果标题1"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="甘肃总成果名单1"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="achievementTitleOneList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写甘肃总成果名单1'"
                        v-model="form.achievementTitleOneList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="甘肃成果标题2"
                    label-position="top"
                >
                    <el-input
                        v-model="form.achievementTitleTwo"
                        placeholder="请输入甘肃成果标题2"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="甘肃总成果名单2"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="achievementTitleTwoList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写甘肃总成果名单2'"
                        v-model="form.achievementTitleTwoList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="甘肃成果标题3"
                    label-position="top"
                >
                    <el-input
                        v-model="form.achievementTitleThree"
                        placeholder="请输入甘肃成果标题3"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="甘肃总成果名单3"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="achievementTitleThreeList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写甘肃总成果名单3'"
                        v-model="form.achievementTitleThreeList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
                <el-form-item
                    label="甘肃成果标题4"
                    label-position="top"
                >
                    <el-input
                        v-model="form.achievementTitleFour"
                        placeholder="请输入甘肃成果标题4"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="甘肃总成果名单4"
                    label-position="top"
                    class='editor'
                >
                    <editor
                        refName="achievementTitleFourList"
                        style='max-height: 500px;overflow-y: auto;'
                        :placeholderText="'请填写甘肃总成果名单4'"
                        v-model="form.achievementTitleFourList"
                        :upload-url="uploadURL"
                        :img-show-url="imgUrl"
                        ></editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button type="warning" @click="dialogFormVisible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonLayout from "../../../components/common-layout.vue";
import editor from "../../../components/tinymce-editor/tinymce-editor";
export default {
    components: {
        CommonLayout,
        editor
    },
    data() {
        return {
            tableData: [], //列表数据
            total: 10, //总页数
            current_page: 1, //当前页
            per_page: 20, //每页条数
            dialogFormVisible: false,
            form: {},
            formLabelWidth: "120px"
        };
    },
    created() {
        this.getData();
    },
    computed: {
    },
    methods: {
        onSubmit() {
            let params = {
                ...this.form,
                isShow: 1,
                id: this.form.id
            }
            this.http.put('apij2/admin-api/voucher/large-screen-technology-transfer-management/update', params).then((response) => {
                if (response.code == 0) {
                    this.$message.success('修改成功');
                    this.getData()
                    this.dialogFormVisible = false;
                }
            });
        },
        handleEdit(item) {
            this.form = {
            }
            this.$nextTick(() => {
                this.form = {...item};
                this.dialogFormVisible = true;
            });
        },
        //获取列表数据
        getData() {
            let params = {
                page: this.current_page,
                pageSize: this.per_page,
            }
            this.http.post('apij2/admin-api/voucher/large-screen-technology-transfer-management/page', params).then((response) => {
                this.tableData = response.data.data;
                this.total = response.data.total; //总页数
                this.per_page = response.data.per_page;
                this.current_page = response.data.current_page;
            });
        },
        //选择页码
        handleCurrentChange(e) {
            this.current_page = e;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
* {
    word-break: normal;
}

.table_container {
    height: 100%;
    text-align: left;

    .handle-box {
        .handle-input {
            /deep/.el-input__suffix {
                margin-right: 10px;
            }
        }
    }

    #table {
        margin-top: 20px;
        border: 1px solid #eef1f6;

        /deep/ th {
            // background-color: #eef1f6 !important;
            // color: #000;
        }

        /deep/ td {}

        /deep/ .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                max-width: 100px;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 10px;
    }

    /deep/ .el-dialog__header {
        text-align: center !important;
    }
}

.mess {
    color: red;
    margin-left: 20px;
}
/deep/ .el-dialogFormVisible__header{
		border-bottom: 1px solid #ccc;
		font-size: 20px;
		font-weight: 500;
		padding-bottom: 20px;
		margin-bottom: 10px;
	}
    /deep/ .el-dialogFormVisible__body{
        padding: 20px;
    }
    .editor{
        /deep/ .el-form-item__content{
            display: inline-block;
        }
    }
</style>
